var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTwitter = function SvgIconTwitter(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.847 10.463 21.127 2h-1.724L13.08 9.35 8.031 2H2.207l7.636 11.112-7.636 8.876h1.725l6.677-7.76 5.332 7.76h5.824l-7.918-11.524Zm-2.363 2.748-.774-1.107-6.156-8.805h2.65l4.968 7.106.774 1.107 6.458 9.236h-2.651l-5.27-7.538Z"
  })));
};
export default SvgIconTwitter;